export default __webpack_public_path__ + "public/icons/RightArrow.svg?71632c251d19e7fb2bf07f7476c10669";